const mediaItems = [
  {
    id: 1,
    title: '独家：疑似某顶流私下聚会视频片段流出',
    duration: '03:25',
    views: '1256万',
    tag: '独家爆料',
    image: 'https://readdy.ai/api/search-image?query=Exclusive%20gossip%20video%20thumbnail%20with%20play%20button%20overlay%2C%20celebrity%20private%20party%20atmosphere%2C%20warm%20dim%20lighting%2C%20entertainment%20news%20style%2C%20coral%20pink%20and%20golden%20tones%2C%20editorial%20quality&width=640&height=400&seq=media-01-cg&orientation=landscape',
  },
  {
    id: 2,
    title: '实拍：综艺录制现场混乱画面独家外泄',
    duration: '05:18',
    views: '987万',
    tag: '现场直击',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20chaotic%20behind%20the%20scenes%20video%20thumbnail%2C%20dramatic%20production%20set%20moment%2C%20warm%20studio%20lighting%2C%20entertainment%20news%20style%2C%20coral%20and%20amber%20tones%2C%20professional%20quality&width=640&height=400&seq=media-02-cg&orientation=landscape',
  },
  {
    id: 3,
    title: '音频曝光：某明星与前经纪人激烈争吵全程',
    duration: '08:42',
    views: '843万',
    tag: '音频爆料',
    image: 'https://readdy.ai/api/search-image?query=Audio%20waveform%20visualization%20with%20dramatic%20entertainment%20news%20aesthetic%2C%20podcast%20style%20thumbnail%2C%20warm%20coral%20pink%20and%20dark%20tones%2C%20editorial%20quality%2C%20professional%20design&width=640&height=400&seq=media-03-cg&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">吃瓜视频</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto">
            51吃瓜网在线观看最新独家吃瓜视频，全网黑料视频与娱乐爆料一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50 group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-2xl md:text-3xl ml-1"></i>
                  </div>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-950/70 text-background-50 text-xs whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-medium text-sm md:text-base text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center text-xs text-foreground-400">
                  <i className="ri-eye-line mr-1"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}